import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import CommunicationsConfig from './communications/CommunicationsConfig';
import GroupsConfig from './groups/GroupsConfig';
import LeaveConfig from './leave/LeaveConfig';
import RequestsConfig from './requests/RequestsConfig';
import SkillsConfig from './skills/SkillsConfig';
import UsersConfig from './users/UsersConfig';
import CoursesConfig from './courses/CoursesConfig';

const modulesConfigs: AppRouteGroup[] = [
	CommunicationsConfig,
	GroupsConfig,
	LeaveConfig,
	RequestsConfig,
	SkillsConfig,
	UsersConfig,
	CoursesConfig
];

export default modulesConfigs;
